// Projects data - Add your projects here
export const projectsData = [
  {
    id: 1,
    title: "Blood Donation Application",
    description: "The Blood Donation Application is a web-based platform designed to connect blood donors with individuals in need of blood. The system simplifies the process of requesting, managing, and donating blood through a secure and role-based environment.This project is built using the MERN stack (MongoDB, Express.js, React, Node.js)",
    technologies: ["React", "Tailwind CSS", "Firebase", "Node.js", "MongoDB"],
    image: "https://i.ibb.co.com/RG0VRKqM/Screenshot-2026-01-01-190555.png",
    liveUrl: "https://unique-bublanina-9b3ac2.netlify.app",
    githubUrl: "https://github.com/Junaid8217/assignment-11-client.git",
    featured: true,
    category: "Web Development"
  },
  {
    id: 2,
    title: "PawMart — Pet Adoption & Supply Portal",
    description: "PawMart is a web-based platform where users can adopt pets or buy pet-related products such as food, accessories, and care items. Pet owners and shop owners can add listings, while buyers can place adoption or order requests easily.",
    technologies: ["React", "Tailwind CSS", "Firebase", "Node.js", "MongoDB"],
    image: "https://i.ibb.co.com/Zp4q6Ngz/Screenshot-2026-01-01-192138.png",
    liveUrl: "https://eloquent-gnome-9281de.netlify.app",
    githubUrl: "https://github.com/Junaid8217/PawMart-client-side.git",
    featured: true,
    category: "Web Development"
  },
  {
    id: 3,
    title: "WarmPaws — Pet Care in Winter",
    description: "WarmPaws is a winter-focused pet care platform that helps pet owners keep their furry friends warm, safe, and healthy during the cold season. Users can explore local pet care services, winter clothing for pets, grooming options, expert tips, and book services easily.",
    technologies: ["React", "Tailwind CSS", "Firebase", "Node.js", "MongoDB"],
    image: "https://i.ibb.co.com/KcJV7VZC/Screenshot-2026-01-05-184859.png",
    liveUrl: "https://stupendous-fox-6aad8d.netlify.app",
    githubUrl: "https://github.com/Junaid8217/warm-paws-website.git",
    featured: false,
    category: "Web Development"
  }
  // {
  //   id: 4,
  //   title: "Weather Dashboard",
  //   description: "Real-time weather application with location-based forecasts, interactive weather maps, and detailed weather analytics.",
  //   technologies: ["JavaScript", "Weather API", "CSS3", "Chart.js"],
  //   image: "https://images.unsplash.com/photo-1504608524841-42fe6f032b4b?w=800&h=600&fit=crop",
  //   liveUrl: "https://your-weather-demo.com", // Replace with your actual URL
  //   githubUrl: "https://github.com/yourusername/weather-dashboard", // Replace with your actual GitHub URL
  //   featured: false,
  //   category: "Web Development"
  // },
  // {
  //   id: 5,
  //   title: "Social Media Analytics",
  //   description: "Analytics dashboard for social media performance tracking with engagement metrics and audience insights.",
  //   technologies: ["React", "D3.js", "Python", "FastAPI"],
  //   image: "https://images.unsplash.com/photo-1611926653458-09294b3142bf?w=800&h=600&fit=crop",
  //   liveUrl: "https://your-analytics-demo.com", // Replace with your actual URL
  //   githubUrl: "https://github.com/yourusername/social-analytics", // Replace with your actual GitHub URL
  //   featured: false,
  //   category: "Data Analytics"
  // },
  // {
  //   id: 6,
  //   title: "Portfolio Website",
  //   description: "Modern, responsive portfolio website built with React and Tailwind CSS, featuring dark mode and smooth animations.",
  //   technologies: ["React", "Tailwind CSS", "Framer Motion"],
  //   image: "https://images.unsplash.com/photo-1467232004584-a241de8bcf5d?w=800&h=600&fit=crop",
  //   liveUrl: "https://your-portfolio-demo.com", // Replace with your actual URL
  //   githubUrl: "https://github.com/yourusername/portfolio", // Replace with your actual GitHub URL
  //   featured: false,
  //   category: "Web Development"
  // }
];

// Helper function to get featured projects
export const getFeaturedProjects = () => {
  return projectsData.filter(project => project.featured);
};

// Helper function to get projects by category
export const getProjectsByCategory = (category) => {
  return projectsData.filter(project => project.category === category);
};

// Helper function to get all categories
export const getCategories = () => {
  return [...new Set(projectsData.map(project => project.category))];
};